import { useQuery } from '@apollo/client'
import PropTypes from 'prop-types'

import { atlasClient } from 'graphql/client'

import { Loader } from 'components/Core'
import ErrorPage from 'components/Error/ErrorPage'

import { favoritedBrandsQuery } from '../queries'
import { getListOfFavorites } from '../utils'
import FavoritesComponent from './Favorites.component'

const FavoritesLoggedInContainer = () => {
  const {
    data: favoritesData,
    loading: favoritesLoading,
    error: favoritesError,
  } = useQuery(favoritedBrandsQuery, {
    client: atlasClient,
  })

  const favoritedBrands = getListOfFavorites(favoritesData)

  if (favoritesLoading) return <Loader active useFullScreen />
  if (favoritesError) {
    return <ErrorPage content="the trade show data" />
  }

  return (
    <FavoritesComponent favoritedBrands={favoritedBrands} isLoggedIn={true} />
  )
}

FavoritesLoggedInContainer.propTypes = {
  trackEventBrandClick: PropTypes.func.isRequired,
}

export default FavoritesLoggedInContainer
